export const PURCHASE_SUBMIT_BUTTON_ID = "checkout-submit-button";

export const INVALID_ELEMENT_STATE_ERROR =
  "Oops! Something went wrong and your purchase could not be completed. Please refresh the page or try again later.";
export const DEFAULT_PAYMENT_CONFIRM_ERROR =
  "Oops! Something went wrong and your purchase could not be completed. Please verify your billing details or use another payment method.";
